import React, { FC, FocusEventHandler } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';

export interface Props {
  id?: string;
  enabled?: boolean;
  placeholder?: string;
  value: string | undefined;
  touched?: boolean;
  error?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: FocusEventHandler<any>;
  role?: string;
  size?: 'sm' | 'lg';
  rest?: Record<string, unknown>;
  style?: React.CSSProperties;
  onReset?: () => void;
  readOnlyMode?: boolean;
  iconComponent?: React.ReactNode;
}

const TextInput: FC<Props> = ({
  id,
  value,
  touched,
  error,
  enabled = true,
  placeholder,
  onChange,
  onBlur,
  role = 'textbox',
  size,
  rest,
  style,
  onReset,
  readOnlyMode,
  iconComponent,
}: Props) => {
  return (
    <div className="text-input-container">
      <InputGroup>
        <FormControl
          type="text"
          name={id}
          size={size}
          value={value}
          isValid={touched && !error}
          isInvalid={touched && !!error}
          disabled={!enabled || readOnlyMode}
          placeholder={readOnlyMode ? '' : placeholder}
          onChange={onChange}
          onBlur={onBlur}
          role={role}
          style={readOnlyMode ? { color: 'rgb(0,0,0,0.5)' } : style}
          {...rest}
        />
        {onReset && value && (
          <InputGroup.Text>
            <div data-testid="reset-icon" onClick={onReset}>
              <span className="mdi mdi-close" />
            </div>
          </InputGroup.Text>
        )}
        {iconComponent && (!onReset || !value) && <InputGroup.Text>{iconComponent}</InputGroup.Text>}
      </InputGroup>
    </div>
  );
};

export default TextInput;
